import {
  CalendarIcon,
  CreditCardIcon,
  KebabHorizontalIcon,
  PencilIcon,
  PersonIcon,
  PlusIcon,
  SyncIcon,
  TrashIcon,
  UndoIcon,
  CopyIcon,
  DownloadIcon,
  KeyIcon,
  XIcon,
} from "@primer/octicons-react";
import { ActionList, ActionMenu, Box, Checkbox, IconButton, Text as PrimerText } from "@primer/react";

import { NumberBox } from "devextreme-react/number-box";
import moment from "moment";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { hoanPhiTongHopApi } from "../../../api/hoanPhiTongHopApi";
import { mucPhaiThuApi } from "../../../api/mucPhaiThuApi";
import { saleSetApi } from "../../../api/saleSetApi";
import { AddKhoanNopFromSaleset } from "../../../components/add-khoanop-modal/add-from-saleset";
import { DefaultConfirm } from "../../../components/confirm";
import DataGrid from "../../../components/data-grid";
import { IDataGridColumn } from "../../../components/data-grid/type/IDataGridProps";
import {
  HocSinhRender,
  Infomation,
} from "../../../components/hoc-sinh/HocSinhRender";
import { DefaultPopup } from "../../../components/modal";
import { FormGroup } from "../../../components/primer-ui/form-group";
import TextAreaAutoHeight from "../../../components/primer-ui/text-area-auto-height";
import ThuPhiChiTiet from "../../../components/thu-phi/chi-tiet";
import { HuyChungTuModal } from "../../../components/thu-phi/huy-chung-tu";
import Button from "../../../components/ui/button";
import Modal from "../../../components/ui/modal";
import ModalActions from "../../../components/ui/modal/ModalActions";
import { PlaceHolder } from "../../../components/place-holder";
import { formatVND } from "../../../utils/formatVND";
import styles from "../../../components/thu-phi/tao-bien-lai/TaoBienLai.module.css";
import Text from "../../../components/ui/text";
import TextWithEllipse from "../../../components/ui/text-with-ellipse";
import { showNotify } from "../../../helpers/toast";
import { PageBaseStatus } from "../../../models/pageBaseStatus";
import { sf_mucphaithu_select_byhocsinh_rq } from "../../../models/request/thu-phi/sf_mucphaithu_select_byhocsinh_rq";
import { create_quyet_toan_request } from "../../../models/request/tonghop/create_quyet_toan_request";
import { sf_hachtoan_congno } from "../../../models/response/hach-toan-cong-no/sf_hachtoan_congno";
import {
  HinhThucThanhToanVm,
  sf_mucphaithu,
} from "../../../models/response/thu-phi/sf_mucphaithu";
import { saveHachToanCongNoStart } from "../../../state/actions/hachToanCongNoActions";
import { hocSinhProfileActions } from "../../../state/actions/hocSinhProfileActions";
import { RootState } from "../../../state/reducers";
import { HachToanCongNoDetailModal } from "../../hach-toan-cong-no/detail_modal/index";
import HoanPhiHocSinhPage from "../../hoan-phi-hoc-sinh";

type HocSinhChungTuProps = {
  ts_hocsinh_id?: number;
  dm_truong_id?: number;
  dm_khoi_id?: number;
  dm_he_id?: number;
}

const HocSinhChungTu = (props: HocSinhChungTuProps = {}) => {
  const {
    filter,
    status,
    sf_mucphaithus,
    isShowThuPhiChiTiet,
    isShowThuPhiAddModal,
    sf_mucphaithu_editing,
    ts_hocsinh_viewmodel,
  } = useSelector((x: RootState) => x.hocSinhProfile);
  const navigate = useNavigate();

  const [isShowConfirmModal, setIsShowConfirmModal] = useState(false);
  const [isShowRefundModal, setIsShowRefundModal] = useState(false);
  const [isShowHoanPhiModal, setIsShowHoanPhiModal] = useState(false);
  const [isShowHuyChungTu, setIsShowHuyChungTu] = useState<boolean>(false);
  const [sf_mucphaithu_hoanphi_id, set_sf_mucphaithu_hoanphi_id] = useState(0);

  const [isShowQuyetToanModal, setIsShowQuyetToanModal] = useState(false);
  const [tong_tien_thua, set_tong_tien_thua] = useState<any>(0);
  const [noi_dung_quyet_toan, set_noi_dung_quyet_toan] = useState("");
  const [so_tien_quyet_toan, set_so_tien_quyet_toan] = useState(0);

  const [soChungTu, setSoChungTu] = useState("");
  const [soTienConDu, setSoTienConDu] = useState(Number);
  const [sf_mucphaithu_root_id, setsf_mucphaithu_root_id] = useState(Number);

  const [maxSoChungTuCT, setMaxSoChungTuCT] = useState("");
  const [maxSoChungTuNO, setMaxSoChungTuNO] = useState("");
  const [isLoadingAddModal, setIsLoadingAddModal] = useState(false);

  const [selectedChungTuQr, setSelectedChungTuQr] = useState<sf_mucphaithu | null>(null);
  const [isShowBidvQrModal, setIsShowBidvQrModal] = useState<boolean>(false);
  const [bidvQrLoading, setBidvQrLoading] = useState<boolean>(false);
  const [bidvQrImage, setBidvQrImage] = useState<string>("");
  const [bidvQrData, setBidvQrData] = useState<any>(null);

  const { nam_hoc, ts_hocsinh_id: filter_ts_hocsinh_id } = filter;
  const ts_hocsinh_id = props?.ts_hocsinh_id ?? ts_hocsinh_viewmodel?.id ?? filter_ts_hocsinh_id;
  const dm_he_id = props?.dm_he_id ?? (filter as any).dm_he_id ?? ts_hocsinh_viewmodel?.dm_he_id;
  const dm_khoi_id = props?.dm_khoi_id ?? (filter as any).dm_khoi_id ?? ts_hocsinh_viewmodel?.dm_khoi_id;
  const dm_truong_id = props?.dm_truong_id ?? (filter as any).dm_truong_id ?? ts_hocsinh_viewmodel?.dm_truong_id;

  const dispatch = useDispatch();
  const handleShowAddModal = async () => {
    if (nam_hoc && ts_hocsinh_id) {
      setIsLoadingAddModal(true);
      try {
        const request = {
          nam_hoc: nam_hoc,
          ts_hocsinh_ids: [ts_hocsinh_id]
        };
        const response = await saleSetApi.syncCongNo(request);

        if (response?.data?.jobId) {
          const jobId = response.data.jobId;

          await new Promise<void>((resolve) => {
            const pollProgress = async () => {
              try {
                const progressResponse = await saleSetApi.syncCongNoProgress(jobId);

                if (!progressResponse?.is_success || progressResponse?.status_code === 400) {
                  resolve();
                  return;
                }

                let progressData = null;
                if (progressResponse?.data) {
                  progressData = progressResponse.data.data || progressResponse.data;
                }

                if (progressData) {
                  const progress = progressData;
                  const isCompleted = progress.IsCompleted !== undefined
                    ? progress.IsCompleted
                    : (progress.isCompleted !== undefined ? progress.isCompleted : false);

                  if (isCompleted === true) {
                    resolve();
                    return;
                  } else {
                    setTimeout(pollProgress, 500);
                  }
                } else {
                  resolve();
                }
              } catch (error) {
                console.error("Lỗi khi poll progress:", error);
                resolve();
              }
            };

            pollProgress();
          });
        }

        await mucPhaiThuApi.sync_tienthua({ ts_hocsinh_id, nam_hoc });
        handleReloadTienThuaHocSinh();

        const hasFullInfo =
          dm_he_id !== undefined && dm_he_id !== null &&
          dm_khoi_id !== undefined && dm_khoi_id !== null &&
          dm_truong_id !== undefined && dm_truong_id !== null;

        if (!hasFullInfo && !ts_hocsinh_viewmodel) {
          const datasend: sf_mucphaithu_select_byhocsinh_rq = {
            ts_hocsinh_id: ts_hocsinh_id,
            nam_hoc: nam_hoc
          };
          dispatch(hocSinhProfileActions.selectHocSinhStart(datasend));
          setTimeout(() => {
            dispatch(hocSinhProfileActions.showThuPhiAddModal());
          }, 300);
        } else {
          dispatch(hocSinhProfileActions.showThuPhiAddModal());
        }
      } catch (error) {
        console.error("Lỗi khi đồng bộ saleset:", error);
      } finally {
        setIsLoadingAddModal(false);
      }
    }
  };

  useEffect(() => {
    if (nam_hoc && ts_hocsinh_id) {
      handleReloadChungTu();
    }
    handleReloadTienThuaHocSinh();
    handleFetchMaxCT();
    handleFetchMaxNO();
  }, [nam_hoc, ts_hocsinh_id]);
  useEffect(() => {
    if (status === PageBaseStatus.is_need_reload) {
      dispatch(hocSinhProfileActions.closeThuPhiAddModal());
      handleReloadChungTu();
      handleSelectLastestChungTu();
      handleReloadTienThuaHocSinh();
    }
  }, [status]);
  const handleReloadChungTu = () => {
    dispatch(
      hocSinhProfileActions.selectChungTuStart({
        nam_hoc,
        ts_hocsinh_id,
      })
    );
  };
  const handleReloadTienThuaHocSinh = async () => {
    const datasend: sf_mucphaithu_select_byhocsinh_rq = {
      ts_hocsinh_id: ts_hocsinh_id,
      nam_hoc: nam_hoc,
    };
    const res = await mucPhaiThuApi.select_tienthua_by_hocsinh(datasend);
    if (res.is_success && res.data && res.data.tong_tien_thua != undefined) {
      set_tong_tien_thua(res.data.tong_tien_thua);
    }
  };
  const handleSelectLastestChungTu = async () => {
    const datasend = {
      nam_hoc: nam_hoc,
      ts_hocsinh_id: ts_hocsinh_viewmodel?.id ?? 0,
    };

    const res = await mucPhaiThuApi.select_by_hocsinh(datasend);
    if (res.is_success) {
      if (res.data !== undefined) {
        dispatch(hocSinhProfileActions.showThuPhiChiTiet(res.data[0]));
      }
    }
  };

  const handleFetchMaxCT = async () => {
    const res = await mucPhaiThuApi.select_max_ct();
    if (res.is_success) {
      setMaxSoChungTuCT(res.data);
    }
  };

  const handleFetchMaxNO = async () => {
    const res = await mucPhaiThuApi.select_max_no();
    if (res.is_success) {
      setMaxSoChungTuNO(res.data);
    }
  };
  const handleCreateChungTu = (data: any) => {
    dispatch(
      hocSinhProfileActions.createThuPhiFromKhoanNopStart({
        nam_hoc: nam_hoc,
        sf_mucphaithu_id: 0,
        ts_hocsinh_id: ts_hocsinh_viewmodel?.id ?? 0,
        is_tinh_mien_giam: data.is_calculate_miengiam,
        sf_mucthuphis: data.sf_mucthuphis.map((x: any) => {
          return {
            id: x.id,
            sf_mucthuphi_id: x.id,
            so_tien_phai_nop: x.so_tien_phai_nop,
            ghi_chu: x.ghi_chu,
          };
        }),
      })
    );
    handleReloadChungTu();
  };
  type ConfirmShowQuyetToanModalProps = {
    onClose: () => void;
    onConfirmed: () => void;
  };
  const ConfirmShowQuyetToanModal = (props: ConfirmShowQuyetToanModalProps) => {
    return (
      <DefaultConfirm
        onClose={() => {
          props.onClose();
        }}
        onConfirmed={() => {
          props.onConfirmed();
        }}
        text={`Bạn có muốn tạo quyết toán từ khoản còn dư này không?`}
        type="success"
        text_close_button="Đóng"
        text_confirm_button="Xác nhận"
      />
    );
  };
  const handleCloseModal = () => {
    setIsShowQuyetToanModal(false);
  };
  const handleSubmitDetailModal = useCallback((data: sf_hachtoan_congno) => {
    dispatch(saveHachToanCongNoStart(data));
    setIsShowQuyetToanModal(false);
  }, []);

  const handleCreateQuyetToan = async () => {
    if (noi_dung_quyet_toan !== "" && so_tien_quyet_toan > 0) {
      const datasend: create_quyet_toan_request = {
        so_tien: so_tien_quyet_toan,
        noi_dung_quyet_toan: noi_dung_quyet_toan,
        nam_hoc: nam_hoc,
      };
      const res = await hoanPhiTongHopApi.create_quyet_toan(datasend);
      if (res.is_success) {
        setIsShowRefundModal(false);
        showNotify({ message: "Tạo quyết toán thành công", type: "success" });
      } else {
        showNotify({
          message: "Tạo quyết toán không thành công",
          type: "warning",
        });
      }
    }
  };

  const handleGenBidvQr = async (targetChungTu?: sf_mucphaithu) => {
    const item = targetChungTu || selectedChungTuQr;
    if (!item) return;
    setBidvQrLoading(true);
    setBidvQrImage("");
    setBidvQrData(null);
    try {
      const res: any = await mucPhaiThuApi.gen_qr({ sf_mucphaithu_id: item.id });
      if (res.is_success && res.data) {
        setBidvQrImage(res.data.qrImage || "");
        setBidvQrData(res.data);
      } else {
        showNotify({ message: res.message || "Không thể tạo mã QR từ BIDV", type: "warning" });
      }
    } catch (error) {
      console.error("BIDV gen_qr error:", error);
      showNotify({ message: "Lỗi kết nối API BIDV", type: "error" });
    } finally {
      setBidvQrLoading(false);
    }
  };

  const handleOpenBidvQr = (data: sf_mucphaithu) => {
    setSelectedChungTuQr(data);
    setIsShowBidvQrModal(true);
    handleGenBidvQr(data);
  };

  const handleDownloadBidvQr = () => {
    if (!bidvQrImage) return;
    const link = document.createElement("a");
    link.href = bidvQrImage.startsWith("data:") ? bidvQrImage : `data:image/png;base64,${bidvQrImage}`;
    link.download = `BIDV_QR_${selectedChungTuQr?.so_chung_tu || "export"}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const columns = useMemo<IDataGridColumn[]>(() => {
    return [
      {
        id: "cmd",
        caption: "Thao tác",
        width: 90,
        align: "center",
        fixed: "left",
        cellRender: (data: sf_mucphaithu) => {
          return (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <ActionMenu>
                <ActionMenu.Anchor>
                  <IconButton
                    icon={KebabHorizontalIcon}
                    variant="invisible"
                    size="small"
                    aria-label="Thao tác"
                  />
                </ActionMenu.Anchor>
                <ActionMenu.Overlay>
                  <ActionList>
                    <ActionList.Item
                      onSelect={() => {
                        dispatch(
                          hocSinhProfileActions.showThuPhiChiTiet(data)
                        );
                      }}
                    >
                      <ActionList.LeadingVisual>
                        <PencilIcon />
                      </ActionList.LeadingVisual>
                      <PrimerText>Sửa chứng từ</PrimerText>
                    </ActionList.Item>
                    <ActionList.Item
                      disabled={data.tong_tien_da_nop > 0}
                      onSelect={() => {
                        handleOpenBidvQr(data);
                      }}
                    >
                      <ActionList.LeadingVisual>
                        <i className="fa fa-qrcode" />
                      </ActionList.LeadingVisual>
                      <PrimerText>Tạo QR BIDV</PrimerText>
                    </ActionList.Item>
                    <ActionList.Item
                      onSelect={() => {
                        set_sf_mucphaithu_hoanphi_id(data.id);
                        setIsShowHoanPhiModal(true);
                      }}
                    >
                      <ActionList.LeadingVisual>
                        <UndoIcon />
                      </ActionList.LeadingVisual>
                      <PrimerText>Tạo hoàn phí</PrimerText>
                    </ActionList.Item>
                    <ActionList.Item
                      disabled={
                        data.sf_hachtoan_congno_id > 0 ||
                        data.so_chung_tu.includes("NO") ||
                        data.so_chung_tu.includes("RV")
                      }
                      onSelect={() => {
                        set_sf_mucphaithu_hoanphi_id(data.id);
                        setIsShowHuyChungTu(true);
                      }}
                    >
                      <ActionList.LeadingVisual>
                        <TrashIcon />
                      </ActionList.LeadingVisual>
                      <PrimerText>Hủy chứng từ</PrimerText>
                    </ActionList.Item>
                  </ActionList>
                </ActionMenu.Overlay>
              </ActionMenu>
            </Box>
          );
        },
      },
      {
        id: "so_chung_tu",
        caption: "Số CT",
        dataField: "so_chung_tu",
        width: 130,
        fixed: "left",
        isMainColumn: true,
        cellRender: (data: any) => (
          <Box
            id={`btnChungTu${data.id}`}
            as="button"
            sx={{
              cursor: "pointer",
              color: "#3c22ff",
              background: "none",
              border: "none",
              padding: 0,
              textDecoration: "underline",
              fontWeight: 600
            }}
            onClick={async () => {
              dispatch(hocSinhProfileActions.showThuPhiChiTiet(data));
            }}
          >
            {data.so_chung_tu}
          </Box>
        ),
      },
      {
        id: "is_da_thanh_toan",
        caption: "Thanh toán",
        dataField: "is_da_thanh_toan",
        width: 120,
        align: "center",
        cellRender: (data: any) => (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Checkbox
              checked={data.tong_tien_da_nop > 0}
            />
          </Box>
        ),
      },
      {
        id: "noi_dung",
        caption: "Nội dung",
        dataField: "noi_dung",
        width: 250,
        cellRender: (data: any) => (
          <TextWithEllipse text={data.noi_dung || ""} lineNumber={2} />
        ),
      },
      {
        id: "tong_tien",
        caption: "Tổng tiền",
        align: "center",
        columns: [
          {
            id: "tong_tien_dinh_muc",
            caption: "Định mức",
            dataField: "tong_tien_dinh_muc",
            width: 120,
            align: "right",
            cellRender: (data: any) => (
              <span>
                {data.tong_tien_dinh_muc.toLocaleString()}
              </span>
            ),
          },
          {
            id: "tong_tien_mien_giam",
            caption: "Miễn giảm",
            dataField: "tong_tien_mien_giam",
            width: 120,
            align: "right",
            cellRender: (data: any) => (
              <span>
                {data.tong_tien_mien_giam.toLocaleString()}
              </span>
            ),
          },
          {
            id: "tong_tien_phai_nop",
            caption: "Phải nộp",
            dataField: "tong_tien_phai_nop",
            width: 120,
            align: "right",
            cellRender: (data: any) => (
              <span>
                {data.tong_tien_phai_nop.toLocaleString()}
              </span>
            ),
          },
          {
            id: "tong_tien_da_nop",
            caption: "Đã nộp",
            dataField: "tong_tien_da_nop",
            width: 120,
            align: "right",
            cellRender: (data: any) => (
              <span>
                {data.tong_tien_da_nop.toLocaleString()}
              </span>
            ),
          },
          {
            id: "tong_tien_thua_thieu",
            caption: "Thừa/thiếu",
            dataField: "tong_tien_thua_thieu",
            width: 120,
            align: "right",
            cellRender: (data: any) => (
              <span>
                {data.tong_tien_thua_thieu.toLocaleString()}
              </span>
            ),
          },
        ],
      },
      {
        id: "hinh_thuc_thanh_toan",
        caption: "Hình thức thanh toán",
        dataField: "hinh_thuc_thanh_toan",
        width: 200,
        cellRender: (data: any) => {
          const danhSach = data?.HinhThucThanhToanVms as
            | HinhThucThanhToanVm[]
            | undefined;

          if (!danhSach || danhSach.length === 0) {
            return <></>;
          }

          return (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
              {danhSach.map((item, index) => {
                if (item.hinh_thuc_thanh_toan === null) {
                  return null;
                }

                return (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      fontSize: 0,
                      lineHeight: 1.5,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        color: "accent.fg",
                        flexShrink: 0,
                      }}
                    >
                      <CreditCardIcon size={14} />
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        flex: 1,
                        minWidth: 0,
                      }}
                    >
                      <TextWithEllipse
                        text={item.hinh_thuc_thanh_toan}
                        lineNumber={1}
                      />
                      <Box as="span" sx={{ color: "fg.muted" }}>:</Box>
                    </Box>
                    <Box
                      as="strong"
                      sx={{
                        fontWeight: "semibold",
                        color: "fg.default",
                        flexShrink: 0,
                        textAlign: "right",
                      }}
                    >
                      {item.so_tien.toLocaleString()}
                    </Box>
                  </Box>
                );
              })}
            </Box>
          );
        },
      },
      {
        id: "nguoi_thu_username",
        caption: "Ngày thu",
        dataField: "nguoi_thu_username",
        width: 150,
        cellRender: (data: any) => {
          const infos: Infomation[] = [
            {
              title: "",
              data: data.nguoi_thu_username,
              icon: <PersonIcon size={14} />,
              fontWeight: "500",
            },
            {
              title: "",
              data:
                moment(data.ngay_thu_thuc_te).format("DD/MM/YYYY") ===
                  "01/01/0001"
                  ? ""
                  : moment(data.ngay_thu_thuc_te).format(
                    "DD/MM/YYYY HH:mm"
                  ),
              icon: <CalendarIcon size={14} />,
            },
          ];
          return <HocSinhRender infors={infos} />;
        },
      },
      {
        id: "ghi_chu",
        caption: "Ghi chú",
        dataField: "ghi_chu",
        width: 300,
        cellRender: (data: any) => (
          <TextWithEllipse text={data.ghi_chu || ""} lineNumber={2} />
        ),
      },
    ];
  }, [dispatch]);

  return (
    <Box sx={{ pl: 1 }}>
      <DataGrid
        title={<Text text="Danh sách chứng từ" sx={{ fontSize: 16, fontWeight: 600 }} />}
        height={window.innerHeight - 310}
        dataSource={sf_mucphaithus}
        isLoading={status === PageBaseStatus.is_loading}
        exportConfig={{
          enable: true,
          fileName: "danh-sach-chung-tu",
        }}
        filterRow={{
          enable: true
        }}
        // searchEnable={true}
        actionComponent={
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, border: "1px solid", borderColor: "border.default", borderRadius: 2, px: 2, py: 0.5, bg: "canvas.subtle" }}>
              <PrimerText sx={{ fontSize: 13, fontWeight: 500 }}>
                CT Max:{" "}
                <Box as="span" sx={{ display: "inline-flex", alignItems: "flex-start", gap: 0.5 }}>
                  <PrimerText sx={{ color: "accent.fg" }}>{maxSoChungTuCT || "---"}</PrimerText>
                  <IconButton
                    icon={CopyIcon}
                    variant="invisible"
                    size="small"
                    onClick={() => {
                      if (maxSoChungTuCT) {
                        navigator.clipboard.writeText(maxSoChungTuCT);
                        showNotify({ message: "Đã sao chép CT Max", type: "success" });
                      }
                    }}
                    aria-label="Copy CT Max"
                    sx={{
                      p: 0,
                      height: 12,
                      width: 12,
                      color: "fg.muted",
                      "& svg": { width: 10, height: 10 },
                      marginTop: "-2px"
                    }}
                  />
                </Box>
              </PrimerText>
              <IconButton
                icon={SyncIcon}
                variant="invisible"
                size="small"
                onClick={handleFetchMaxCT}
                aria-label="Reload CT Max"
                sx={{ p: 1, height: "auto", width: "auto" }}
              />
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, border: "1px solid", borderColor: "border.default", borderRadius: 2, px: 2, py: 0.5, bg: "canvas.subtle" }}>
              <PrimerText sx={{ fontSize: 13, fontWeight: 500 }}>
                NO Max:{" "}
                <Box as="span" sx={{ display: "inline-flex", alignItems: "flex-start", gap: 0.5 }}>
                  <PrimerText sx={{ color: "accent.fg" }}>{maxSoChungTuNO || "---"}</PrimerText>
                  <IconButton
                    icon={CopyIcon}
                    variant="invisible"
                    size="small"
                    onClick={() => {
                      if (maxSoChungTuNO) {
                        navigator.clipboard.writeText(maxSoChungTuNO);
                        showNotify({ message: "Đã sao chép NO Max", type: "success" });
                      }
                    }}
                    aria-label="Copy NO Max"
                    sx={{
                      p: 0,
                      height: 12,
                      width: 12,
                      color: "fg.muted",
                      "& svg": { width: 10, height: 10 },
                      marginTop: "-2px"
                    }}
                  />
                </Box>
              </PrimerText>
              <IconButton
                icon={SyncIcon}
                variant="invisible"
                size="small"
                onClick={handleFetchMaxNO}
                aria-label="Reload NO Max"
                sx={{ p: 1, height: "auto", width: "auto" }}
              />
            </Box>

            <Button
              text="Thêm chứng từ"
              leadingVisual={PlusIcon}
              variant="primary"
              size="small"
              onClick={handleShowAddModal}
              isLoading={isLoadingAddModal}
            />
            <Button
              text="Làm mới"
              leadingVisual={SyncIcon}
              variant="default"
              size="small"
              onClick={() => {
                dispatch(
                  hocSinhProfileActions.selectChungTuStart({
                    nam_hoc,
                    ts_hocsinh_id,
                  })
                );
                dispatch(
                  hocSinhProfileActions.selectHocSinhStart({
                    nam_hoc,
                    ts_hocsinh_id,
                  })
                );
                dispatch(hocSinhProfileActions.closeThuPhiChiTiet());
                handleFetchMaxNO();
              }}
            />
          </Box>
        }
        columns={columns}
      />
      {isShowThuPhiChiTiet && sf_mucphaithu_editing && (
        <ThuPhiChiTiet
          animationOf={`#btnChungTu${sf_mucphaithu_editing.id}`}
          sf_mucphaithu={sf_mucphaithu_editing}
          onClose={() => {
            dispatch(hocSinhProfileActions.closeThuPhiChiTiet());
            dispatch(
              hocSinhProfileActions.selectChungTuStart({
                nam_hoc,
                ts_hocsinh_id,
              })
            );
          }}
          ts_hocsinh={ts_hocsinh_viewmodel}
          nam_hoc={nam_hoc}
        />
      )}
      {isShowQuyetToanModal && (
        <HachToanCongNoDetailModal
          title={`Quyết toán còn dư của chứng từ ${soChungTu}`}
          onClose={handleCloseModal}
          onSubmit={handleSubmitDetailModal}
          is_saving={status === PageBaseStatus.is_saving}
          nam_hoc={nam_hoc}
          animationOf={"#btnInsert"}
          dm_truong_id={ts_hocsinh_viewmodel?.dm_truong_id}
          ts_hocsinh={ts_hocsinh_viewmodel}
          con_du={soTienConDu}
          sf_mucphaithu_root_id={sf_mucphaithu_root_id}
        />
      )}
      {isShowHoanPhiModal && (
        <HoanPhiHocSinhPage
          onClose={() => {
            setIsShowHoanPhiModal(false);
          }}
          sf_mucphaithu_id={sf_mucphaithu_hoanphi_id}
          ts_hocsinh_id={ts_hocsinh_id}
          nam_hoc={nam_hoc}
        />
      )}
      {isShowThuPhiAddModal && ts_hocsinh_id && nam_hoc && (
        <AddKhoanNopFromSaleset
          nam_hoc={nam_hoc}
          ts_hocsinh_id={ts_hocsinh_id}
          isSaving={status === PageBaseStatus.is_saving}
          ngay_nhap_hoc_lai={ts_hocsinh_viewmodel?.ngay_nhap_hoc_lai}
          onCancel={() => {
            window.animationHidePopup("btnAddNew");
            dispatch(hocSinhProfileActions.closeThuPhiAddModal());
          }}
          onSelected={handleCreateChungTu}
        />
      )}
      {isShowConfirmModal && (
        <ConfirmShowQuyetToanModal
          onClose={() => {
            setIsShowConfirmModal(false);
          }}
          onConfirmed={() => {
            setIsShowConfirmModal(false);
            setIsShowQuyetToanModal(true);
            handleReloadChungTu();
          }}
        />
      )}
      {isShowHuyChungTu && (
        <HuyChungTuModal
          onClose={() => {
            setIsShowHuyChungTu(false);
          }}
          sf_mucphaithu_id={sf_mucphaithu_hoanphi_id}
          onChanged={() => {
            setIsShowHuyChungTu(false);
            handleReloadChungTu();
          }}
        />
      )}
      {isShowRefundModal && (
        <DefaultPopup
          title="Tạo quyết toán hoàn trả phụ huynh"
          onClose={() => {
            setIsShowRefundModal(false);
          }}
        >
          <div className="pop-up-form">
            <div className="col-md-12 padding-top-1rem">
              <Box sx={{ width: 500 }}>
                <FormGroup label="Nội dung (*)">
                  <TextAreaAutoHeight
                    block
                    value={noi_dung_quyet_toan}
                    onValueChanged={(value) => {
                      set_noi_dung_quyet_toan(value);
                    }}
                  />
                </FormGroup>
                <FormGroup label="Số tiền">
                  <NumberBox
                    width={"100%"}
                    stylingMode="outlined"
                    value={0}
                    onValueChanged={(value) => {
                    }}
                  />
                </FormGroup>
              </Box>
            </div>
          </div>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "7px",
              mt: 5,
            }}
          >
            <Button
              variant="default"
              onClick={() => {
                setIsShowRefundModal(false);
              }}
              leadingVisual={SyncIcon}
              text="Đóng"
            />
            <Button
              variant="primary"
              onClick={handleCreateQuyetToan}
              leadingVisual={PlusIcon}
              text="Tạo quyết toán"
            />
          </Box>
        </DefaultPopup>
      )}

      {isShowBidvQrModal && (
        <Modal
          title="Mã QR BIDV (API đối tác)"
          width="60%"
          isOpen={isShowBidvQrModal}
          onClose={() => setIsShowBidvQrModal(false)}
        >
          <div className={styles.qrContainer}>
            <div className={styles.qrTitle}>Mã QR từ BIDV API</div>
            <div className={styles.qrSubtitle}>Mã QR được tạo trực tiếp từ hệ thống BIDV</div>
            {bidvQrLoading ? (
              <div style={{ padding: "40px 0", textAlign: "center", width: "100%" }}>
                <PlaceHolder line_number={5} />
                <div style={{ marginTop: "12px", color: "#586069" }}>Đang gọi API BIDV tạo mã QR...</div>
              </div>
            ) : bidvQrImage ? (
              <>
                <div className={styles.qrImageSection}>
                  <img
                    src={bidvQrImage.startsWith("data:") ? bidvQrImage : `data:image/png;base64,${bidvQrImage}`}
                    alt="BIDV QR"
                    className={styles.qrImage}
                  />
                  <button className={styles.downloadButton} onClick={handleDownloadBidvQr}>
                    <DownloadIcon /> Tải ảnh QR
                  </button>
                </div>
                {bidvQrData && (
                  <div className={styles.qrDetailsSection}>
                    <div className={styles.detailRow}>
                      <span className={styles.detailLabel}>Số tài khoản</span>
                      <span className={styles.detailValue} style={{ fontWeight: "bold" }}>2892899998 (Ngân hàng BIDV)</span>
                    </div>
                    <div className={styles.detailRow}>
                      <span className={styles.detailLabel}>Mã khách hàng</span>
                      <span className={styles.detailValue}>{bidvQrData.code || ""}</span>
                    </div>
                    <div className={styles.detailRow}>
                      <span className={styles.detailLabel}>Tên</span>
                      <span className={styles.detailValue}>{bidvQrData.name || ""}</span>
                    </div>
                    <div className={styles.detailRow}>
                      <span className={styles.detailLabel}>Số tiền</span>
                      <span className={styles.detailValue} style={{ fontWeight: "bold", color: "#cf222e" }}>
                        {formatVND(Number(bidvQrData.amount) || 0)} đ
                      </span>
                    </div>
                    <div className={styles.detailRow} style={{ borderBottom: "none" }}>
                      <span className={styles.detailLabel}>Nội dung</span>
                      <span className={styles.detailValue}>{bidvQrData.description || ""}</span>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div style={{ color: "#d73a49", padding: "20px 0", textAlign: "center" }}>Không thể tạo mã QR từ BIDV.</div>
            )}
            <ModalActions>
              <Button variant="default" leadingVisual={XIcon} text="Đóng" onClick={() => setIsShowBidvQrModal(false)} />
              <Button variant="default" leadingVisual={KeyIcon} text="Tạo lại QR" onClick={() => handleGenBidvQr()} isLoading={bidvQrLoading} />
            </ModalActions>
          </div>
        </Modal>
      )}
    </Box>
  );
};

export default HocSinhChungTu;
